import NoAccess from 'components/NoAccess'

export default function PageNotFound() {
  return (
    <NoAccess
      title="Page Not Found"
      message="The page you are looking for does not exist or may have been moved."
      animationUrl="https://lottie.host/f57ca1f2-6a95-4fd9-b33c-52d931a9c84b/4ICU5KDrBV.json"
      maxWidth={400}
    />
  )
}
